"use strict";

module.exports = {
    View: require('./LeadDetails')
};
